import { BFF_BASE_URL } from 'utils/api-urls';

export const TOTAL_FIELDS_STORAGE_NAME = 'lead_total_fields';
export const LEAD_REQUISITES_STORAGE_NAME = 'lead_requisites';
export const LEAD_CATEGORY_STORAGE_NAME = 'lead_category';
export const LEAD_REVENUE_STORAGE_NAME = 'lead_revenue';
export const LEAD_REVENUE_ID_STORAGE_NAME = 'lead_revenue_id';
export const SESSION_ID_STORAGE_NAME = 'sessionid';

export const LEAD_ID_COOKIE_NAME = 'leadId';

export const LEAD_PROFILE_COOKIE_NAME = 'leadProfile';
export const UNQUALIFIED_SEGMENTS_KEY = 'unqualified_segments';
export const LEAD_TRACKING_STORAGE_KEY = 'olist-lead-tracking';

export const MOBILE_USER_AGREEMENT_URL = 'https://olist.com/termos-de-uso-mobile/';
export const USER_AGREEMENT_URL = 'https://olist.com/termos-de-uso/';

export const MOBILE_PRIVACY_POLICY_URL = 'https://olist.com/politica-de-privacidade-mobile/';
export const PRIVACY_POLICY_URL = 'https://olist.com/politica-de-privacidade/';

export const API_URLS = {
  getLeadQualification: ({ leadId }) => `/api/leads/${leadId}/qualification/`,
  getUnqualifiedProfile: ({ leadId }) => `${BFF_BASE_URL}/leadsV2/unqualified/${leadId}`,
  postAccountCreation: `${BFF_BASE_URL}/leadsV2/create-account`,
  getRequisites: ({ leadId }) => `${BFF_BASE_URL}/leadsV2/${leadId}/requisites/`,
  getCategories: `${BFF_BASE_URL}/leadsV2/categories`,
  getRevenues: `${BFF_BASE_URL}/leadsV2/revenues`,
  patchRevenues: `${BFF_BASE_URL}/leadsV2/revenues`,
  getTermsOfService: `${BFF_BASE_URL}/terms/terms-of-service`,
  getFulfillmentTerms: `${BFF_BASE_URL}/terms/fulfillment-terms`,
  postAcceptTerms: `${BFF_BASE_URL}/terms/accept-terms`,
};

export const WEBAPP_VIEWS_URLS = {
  firstSteps: '/onboarding/first-steps/',
  login: '/login',
};

export const SOURCE_APP_URL_PARAM = 'app';

export const SIGNUP_SOURCE_TYPE = {
  mobile: 'mobile',
  webapp: 'site',
};

export const isMobileSource = (sourceParam) => sourceParam === SOURCE_APP_URL_PARAM;

export const checkSourceTypeParam = (sourceParam) =>
  isMobileSource(sourceParam) ? SIGNUP_SOURCE_TYPE.mobile : SIGNUP_SOURCE_TYPE.webapp;

export const MIXPANEL_EVENTS = {
  LEAD_INSERTED_EMAIL: 'Lead Inserted Email',
  VIEWED_REQUIREMENTS_MODAL: 'Viewed Requirements Modal',
  CLICKED_CATEGORIES_PAGE_HELP_LINK: 'Clicked Categories Page Help Link',
  ANSWERED_CATEGORIES: 'Answered Categories',
  ANSWERED_REVENUE: 'Answered Revenue',
  CLICKED_TO_SEE_TINY: 'Clicked to See Tiny',
  CLICKED_TO_SEE_CORA: 'Clicked to See Cora',
  CLICKED_TO_SEE_MORE_ABOUT_ALLOWED_MEASURES: 'Clicked to See more about allowed measures',
  SIGNUP_COMPLETE: 'Signup Completed',
  EXPERIMENT_STARTED: '$experiment_started',
  EXPERIMENT_SKU_VARIANT: {
    'Experiment name': 'SKU qualification experiment',
    'Variant name': 'SKU qualification variant',
  },
  EXPERIMENT_SKU_ORIGINAL: {
    'Experiment name': 'SKU qualification experiment',
    'Variant name': 'Current flow',
  },
};

export const leadsAllGTMProducts = [
  {
    name: 'pre-signup',
    id: 'pre-signup',
    category: 'setup',
    list: 'web',
    price: '5',
    quantity: 1,
  },
  {
    name: 'requisites',
    id: 'requisites',
    category: 'setup',
    list: 'web',
    price: '3',
    quantity: 1,
  },
  {
    name: 'categories',
    id: 'categories',
    category: 'setup',
    list: 'web',
    price: '1',
    quantity: 1,
  },
];

export const GTM_EVENTS = {
  SIGNUP_EVENT: 'enviosignup_gtm',
  SUBSCRIBED_EVENT: 'enviopql_gtm',
};
